import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/sa/digitize.webp";

function Revolution(props) {
  return (
    <div
      className="revolution_gcc p-100"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>
              Digitize Your Business with a Top Leading Mobile App Agency
              Company in Saudi Arabia
            </h2>
            <p>
              The digital landscape of innovation in Saudi Arabia is evolving at
              a rapid pace. The whole idea of business digitization has highly
              influenced the whole GCC regions and that’s why there is an
              accelerating boost in its tech industry. Every other business
              prioritizes innovating their business with mobile app development
              in the KSA considering it the most user-approachable medium.
            </p>
            <p>
              However, TekRevol stands tall among the best mobile app
              development companies in Saudi Arabia due to its proven experience
              based on continual tech evolution. The mobile app solutions we
              offer are unique and developed in a manner to support business
              scalability leading toward optimal sustainability.
            </p>
            <p>
              So, connect with our app developers in KSA and digitize your
              business to expand its horizon globally.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              {" "}
              Let’s Get Started
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolution;
